import { UserDataType } from '@/store/app'
import request from '@/utils/request'

/** 查询院系管理列表(游客) */
export const getFacultyList = (data: AnyObject) => {
  return request<{
    data: {
      id: number
      name: string
      /** 以逗号分隔 */
      major: string
      icon: string
      /** 创办时间 */
      startDate: string
    }[]
  }>({
    url: `/web/listFaculty`,
    method: 'get',
    params: data,
  })
}

/** web客户端用户注册 */
export function webRegister(data: AnyObject) {
  return request({
    url: '/webRegister',
    method: 'post',
    data: data,
    isShowError: true,
  })
}

/** 生成验证码 */
export function getCaptchaImage() {
  return request<{ img: string; uuid: string }>({
    url: '/captchaImage',
    method: 'get',
  })
}

/** web客户端登录方法 */
export function webLogin(data: AnyObject) {
  return request<{
    token: string
  }>({
    url: '/webLogin',
    method: 'post',
    data: data,
    isShowError: true,
  })
}

/** 获取用户信息 */
export function webGetInfo() {
  return request<{
    user: UserDataType
  }>({
    url: '/client/web/user/getInfo',
    method: 'get',
  })
}
